<template>
<div class="videos-wrapper">
    <div class="d-flex px-2 my-2" style="flex-wrap: wrap;gap:32px;">
        <div v-for="(video, index) in videos" :key="index" class="video-item-container">
            <div v-if="video.url" class="video-container">
                <div class="viewport">
                    <iframe 
                        width="100%" height="100%"
                        :src="video.url"
                        :title="video.description"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                        allowfullscreen></iframe>
                </div>
            </div>
            <p class="text-muted">{{ video.description }}</p>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        videos: { type: Array, required: true },
    },
    data() {
        return {};
    },
}
</script>

<style lang="scss" scoped>
.videos-wrapper {
    margin: 0 auto;
    max-width: 1280px;

    .video-item-container {
        @media screen and (min-width: 768px) {
            width: unset;
            flex: 1;
        }
        flex: none;
        width: 100%;
        flex-wrap: wrap;
    }

    .video-container {
        margin: 0 auto;
        border-radius: 4px;
        overflow: hidden;

        .viewport {
            padding-bottom: 56.25%;
            position: relative;
        }

        iframe {
            position: absolute;
            top: 0;
            left: 0;
        }
    }
}
</style>
